module.exports = __webpack_public_path__ + "img/icon-center.ec67d24a.png";